import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DeviceManagementCard from "./DeviceManagementCard";
import { searchDeviceMgmt } from "../Actions/DeviceManagement";
import DatePicker from "react-datepicker";
import Moment from 'moment';
import swal from "sweetalert";
import Role from "../helpers/role";

const SearchItem = {
    manufacturingFrom: '',
    manufacturingTo: '',
    lastCalibrationFrom: '',
    lastCalibrationTo: '',
    nextCalibrationFrom: '',
    nextCalibrationTo: '',
    id: '',
    make: '',
    modal: '',
    // manufacturingDate: '',
    manufacturingFromDate: '',
    manufacturingToDate: '',
    companyName: '',
    shipName: '',
    pageNumber: 1,
    pageSize: 25
}

let userRole = localStorage.getItem("UserRoles");

class DeviceManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            SelectedManufacturingFromDate: '',
            SelectedManufacturingToDate: '',
            SelectedLastcaliberationFromDate: '',
            SelectedLastcaliberationToDate: '',
            SelectedNextcaliberationFromDate: '',
            SelectedNextcaliberationToDate: '',
            SelectedManufacturingDate: '',
            SelectedFromDate: '',
            SelectedToDate: '',
            manufacturingFromDate: '',
            manufacturingToDate: '',
            fromDate: '',
            toDate: '',
            manufacturingDatePickerIsOpen: false,
            fromDatePickerManufacturingIsOpen: false,
            toDatePickerManufacturingIsOpen: false,
            fromDatePickerLastCalibIsOpen: false,
            toDatePickerLastCalibIsOpen: false,
            fromDatePickerNextCalibIsOpen: false,
            toDatePickerNextCalibIsOpen: false,
            searchData: {
                manufacturingFrom: '',
                manufacturingTo: '',
                lastCalibrationFrom: '',
                lastCalibrationTo: '',
                nextCalibrationFrom: '',
                nextCalibrationTo: '',
                id: '',
                make: '',
                modal: '',
                manufacturingFromDate: '',
                manufacturingToDate: '',
                lastCalibrationDate: '',
                nextCalibrationDate: '',
                companyName: '',
                shipName: '',
                pageNumber: 1,
                pageSize: 25
            },
            isMobile: false,
        }
        this.SearchData = this.SearchData.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.openManufacturingFromDatePicker = this.openManufacturingFromDatePicker.bind(this);
        this.openManufacturingToDatePicker = this.openManufacturingToDatePicker.bind(this);
        this.handleManufacturingFromDateChange = this.handleManufacturingFromDateChange.bind(this);
        this.handleManufacturingToDateChange = this.handleManufacturingToDateChange.bind(this);
        this.openLastCaliberationFromDatePicker = this.openLastCaliberationFromDatePicker.bind(this);
        this.openLastCaliberationToDatePicker = this.openLastCaliberationToDatePicker.bind(this);
        this.handleLastCaliberationFromDateChange = this.handleLastCaliberationFromDateChange.bind(this);
        this.handleLastCaliberationToDateChange = this.handleLastCaliberationToDateChange.bind(this);
        this.openNextCaliberationFromDatePicker = this.openNextCaliberationFromDatePicker.bind(this);
        this.openNextCaliberationToDatePicker = this.openNextCaliberationToDatePicker.bind(this);
        this.handleNextCaliberationFromDateChange = this.handleNextCaliberationFromDateChange.bind(this);
        this.handleNextCaliberationToDateChange = this.handleNextCaliberationToDateChange.bind(this);
    }
    componentDidMount() {
        this.props.dispatch({ type: 'SubBannerTitle', data: "Device Management" });
        this.props.dispatch(searchDeviceMgmt(this.state.searchData));
        this.interval = setInterval(() => {
            this.resize();
        }, 10);
    }

    resize = () => {
        if (window.innerWidth < 600) {
            this.setState({
                isMobile: true,
            });
        } else {
            this.setState({
                isMobile: false,
            });
        }
    };
    SearchData(Pgno) {
        const { dispatch } = this.props;
        if (this.state.searchData.manufacturingTo !== "" && this.state.searchData.manufacturingFrom === "") {
            swal('Error!', 'Please select the manufacturing from date', 'warning')
        }
        if (this.state.searchData.manufacturingTo === "") {
            if (this.state.searchData.manufacturingFrom > Moment().format("YYYY-MM-DD")) {
                swal('Error!', 'Please select the manufacturing  to date', 'warning')
            }
        }
        if (this.state.searchData.manufacturingFrom !== "" && this.state.searchData.manufacturingTo === "" && this.state.searchData.manufacturingFrom < Moment().format("YYYY-MM-DD")) {
            this.state.searchData.manufacturingTo = Moment().format("YYYY-MM-DD");
            this.setState({})
            this.state.searchData.pageNumber = Pgno;
            dispatch(searchDeviceMgmt(this.state.searchData));
        }
        if (this.state.searchData.lastCalibrationTo !== "" && this.state.searchData.lastCalibrationFrom === "") {
            swal('Error!', 'Please select the lastcalibration from date', 'warning')
        }
        if (this.state.searchData.lastCalibrationTo === "") {
            if (this.state.searchData.lastCalibrationFrom > Moment().format("YYYY-MM-DD")) {
                swal('Error!', 'Please select the lastcalibration to date', 'warning')
            }
        }
        if (this.state.searchData.lastCalibrationFrom !== "" && this.state.searchData.lastCalibrationTo === "" && this.state.searchData.lastCalibrationFrom < Moment().format("YYYY-MM-DD")) {
            this.state.searchData.lastCalibrationTo = Moment().format("YYYY-MM-DD");
            this.setState({})
            this.state.searchData.pageNumber = Pgno;
            dispatch(searchDeviceMgmt(this.state.searchData));
        }
        if (this.state.searchData.nextCalibrationTo !== "" && this.state.searchData.nextCalibrationFrom === "") {
            swal('Error!', 'Please select the nextcalibration from date', 'warning')
        }
        if (this.state.searchData.nextCalibrationTo === "") {
            if (this.state.searchData.nextCalibrationFrom > Moment().format("YYYY-MM-DD")) {
                swal('Error!', 'Please select the nextcalibration to date', 'warning')
            }
        }
        if (this.state.searchData.nextCalibrationFrom !== "" && this.state.searchData.nextCalibrationTo === "" && this.state.searchData.nextCalibrationFrom < Moment().format("YYYY-MM-DD")) {
            this.state.searchData.nextCalibrationTo = Moment().format("YYYY-MM-DD");
            this.setState({})
            this.state.searchData.pageNumber = Pgno;
            dispatch(searchDeviceMgmt(this.state.searchData));
        }
        if (this.state.searchData.manufacturingFrom === "" && this.state.searchData.manufacturingTo === "" && this.state.searchData.lastCalibrationFrom === "" && this.state.searchData.lastCalibrationTo === ""
            && this.state.searchData.nextCalibrationFrom === "" && this.state.searchData.nextCalibrationTo === "") {
            this.state.searchData.pageNumber = Pgno;
            dispatch(searchDeviceMgmt(this.state.searchData));
        }
        if (this.state.searchData.manufacturingFrom !== "" && this.state.searchData.manufacturingTo !== "" && this.state.searchData.lastCalibrationFrom !== "" && this.state.searchData.lastCalibrationTo !== ""
            && this.state.searchData.nextCalibrationFrom !== "" && this.state.searchData.nextCalibrationTo !== "") {
            this.state.searchData.pageNumber = Pgno;
            dispatch(searchDeviceMgmt(this.state.searchData));
        }
        if (this.state.searchData.manufacturingFrom !== "" && this.state.searchData.manufacturingTo !== "" && this.state.searchData.lastCalibrationFrom === "" && this.state.searchData.lastCalibrationTo === ""
            && this.state.searchData.nextCalibrationFrom === "" && this.state.searchData.nextCalibrationTo === "") {
            this.state.searchData.pageNumber = Pgno;
            dispatch(searchDeviceMgmt(this.state.searchData));
        }
        if (this.state.searchData.manufacturingFrom === "" && this.state.searchData.manufacturingTo === "" && this.state.searchData.lastCalibrationFrom !== "" && this.state.searchData.lastCalibrationTo !== ""
            && this.state.searchData.nextCalibrationFrom === "" && this.state.searchData.nextCalibrationTo === "") {
            this.state.searchData.pageNumber = Pgno;
            dispatch(searchDeviceMgmt(this.state.searchData));
        }
        if (this.state.searchData.manufacturingFrom === "" && this.state.searchData.manufacturingTo === "" && this.state.searchData.lastCalibrationFrom === "" && this.state.searchData.lastCalibrationTo === ""
            && this.state.searchData.nextCalibrationFrom !== "" && this.state.searchData.nextCalibrationTo !== "") {
            this.state.searchData.pageNumber = Pgno;
            dispatch(searchDeviceMgmt(this.state.searchData));
        }
        if (this.state.searchData.manufacturingFrom !== "" && this.state.searchData.manufacturingTo !== "" && this.state.searchData.lastCalibrationFrom !== "" && this.state.searchData.lastCalibrationTo !== ""
            && this.state.searchData.nextCalibrationFrom === "" && this.state.searchData.nextCalibrationTo === "") {
            this.state.searchData.pageNumber = Pgno;
            dispatch(searchDeviceMgmt(this.state.searchData));
        }
        if (this.state.searchData.manufacturingFrom === "" && this.state.searchData.manufacturingTo === "" && this.state.searchData.lastCalibrationFrom !== "" && this.state.searchData.lastCalibrationTo !== ""
            && this.state.searchData.nextCalibrationFrom !== "" && this.state.searchData.nextCalibrationTo !== "") {
            this.state.searchData.pageNumber = Pgno;
            dispatch(searchDeviceMgmt(this.state.searchData));
        }
        if (this.state.searchData.manufacturingFrom !== "" && this.state.searchData.manufacturingTo !== "" && this.state.searchData.lastCalibrationFrom === "" && this.state.searchData.lastCalibrationTo === ""
            && this.state.searchData.nextCalibrationFrom !== "" && this.state.searchData.nextCalibrationTo !== "") {
            this.state.searchData.pageNumber = Pgno;
            dispatch(searchDeviceMgmt(this.state.searchData));
        }



    }

    ClearInput() {
        this.state.SelectedManufacturingFromDate = '';
        this.state.SelectedManufacturingToDate = '';
        this.state.SelectedLastcaliberationFromDate = '';
        this.state.SelectedLastcaliberationToDate = '';
        this.state.SelectedNextcaliberationFromDate = '';
        this.state.SelectedNextcaliberationToDate = '';
        this.setState({})
        let param = { ...SearchItem }
        this.setState({
            searchData: param
        }, () => {
            this.props.dispatch(searchDeviceMgmt(this.state.searchData));
        })
    }
    handleBlur() {
        this.setState({
            manufacturingDatePickerIsOpen: false,
            fromDatePickerManufacturingIsOpen: false,
            toDatePickerManufacturingIsOpen: false,
            fromDatePickerLastCalibIsOpen: false,
            toDatePickerLastCalibIsOpen: false,
            fromDatePickerNextCalibIsOpen: false,
            toDatePickerNextCalibIsOpen: false,
        });
    }
    handleManufacturingFromDateChange(date) {
        this.state.searchData.manufacturingFrom = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
        this.setState({
            SelectedManufacturingFromDate: date,
            fromDatePickerManufacturingIsOpen: false
        });
    }
    handleManufacturingToDateChange(date) {
        this.state.searchData.manufacturingTo = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
        this.setState({
            SelectedManufacturingToDate: date,
            toDatePickerManufacturingIsOpen: false
        });
    }
    handleLastCaliberationFromDateChange(date) {
        this.state.searchData.lastCalibrationFrom = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
        this.setState({
            SelectedLastcaliberationFromDate: date,
            fromDatePickerLastCalibIsOpen: false
        });
    }

    handleLastCaliberationToDateChange(date) {
        this.state.searchData.lastCalibrationTo = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
        this.setState({
            SelectedLastcaliberationToDate: date,
            toDatePickerLastCalibIsOpen: false
        });
    }


    handleNextCaliberationFromDateChange(date) {
        this.state.searchData.nextCalibrationFrom = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
        this.setState({
            SelectedNextcaliberationFromDate: date,
            fromDatePickerNextCalibIsOpen: false
        });
    }

    handleNextCaliberationToDateChange(date) {
        this.state.searchData.nextCalibrationTo = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
        this.setState({
            SelectedNextcaliberationToDate: date,
            toDatePickerNextCalibIsOpen: false
        });
    }
    openManufacturingFromDatePicker() {
        this.setState({
            toDatePickerManufacturingIsOpen: false,
            fromDatePickerManufacturingIsOpen: !this.state.fromDatePickerManufacturingIsOpen,
            toDatePickerLastCalibIsOpen: false,
            fromDatePickerLastCalibIsOpen: false,
            toDatePickerNextCalibIsOpen: false,
            fromDatePickerNextCalibIsOpen: false,
        });
    };
    openManufacturingToDatePicker() {
        this.setState({
            fromDatePickerManufacturingIsOpen: false,
            toDatePickerManufacturingIsOpen: !this.state.toDatePickerManufacturingIsOpen,
            toDatePickerLastCalibIsOpen: false,
            fromDatePickerLastCalibIsOpen: false,
            toDatePickerNextCalibIsOpen: false,
            fromDatePickerNextCalibIsOpen: false,
        });
    };
    openLastCaliberationFromDatePicker() {
        this.setState({
            toDatePickerLastCalibIsOpen: false,
            fromDatePickerLastCalibIsOpen: !this.state.fromDatePickerLastCalibIsOpen,
            toDatePickerManufacturingIsOpen: false,
            fromDatePickerManufacturingIsOpen: false,
            toDatePickerNextCalibIsOpen: false,
            fromDatePickerNextCalibIsOpen: false,
        });
    };

    openLastCaliberationToDatePicker() {
        this.setState({
            fromDatePickerLastCalibIsOpen: false,
            toDatePickerLastCalibIsOpen: !this.state.toDatePickerLastCalibIsOpen,
            toDatePickerManufacturingIsOpen: false,
            fromDatePickerManufacturingIsOpen: false,
            toDatePickerNextCalibIsOpen: false,
            fromDatePickerNextCalibIsOpen: false,
        });
    };
    openNextCaliberationFromDatePicker() {
        this.setState({
            toDatePickerNextCalibIsOpen: false,
            fromDatePickerNextCalibIsOpen: !this.state.fromDatePickerNextCalibIsOpen,
            toDatePickerManufacturingIsOpen: false,
            fromDatePickerManufacturingIsOpen: false,
            toDatePickerLastCalibIsOpen: false,
            fromDatePickerLastCalibIsOpen: false,
        });
    };

    openNextCaliberationToDatePicker() {
        this.setState({
            fromDatePickerNextCalibIsOpen: false,
            toDatePickerNextCalibIsOpen: !this.state.toDatePickerNextCalibIsOpen,
            toDatePickerManufacturingIsOpen: false,
            fromDatePickerManufacturingIsOpen: false,
            toDatePickerLastCalibIsOpen: false,
            fromDatePickerLastCalibIsOpen: false,
        });
    };
    NewitemNav = () => {
        const { dispatch, history } = this.props;
        history.push("/Home/Management/AddDevice");
        dispatch({ type: "ShowSidePan", data: false });
    };

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.searchData[nodeName] = e.target.value;
        this.setState({
        });
    }
    BacktoPrevious() {
        this.props.history.goBack();
    }

    render() {
        const { SearchDevice, showSidePane } = this.props;
        return (
            <div className="full-height">
                <div className="pt-3">
                    <div className="row px-3 pb-3">
                        <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            onClick={() => this.BacktoPrevious()}
                        >
                            <div style={{ position: 'relative' }}>
                                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
                            </div>
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="panel-box">
                                <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                    <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                                        <h5 className="card-title ml-2 mt-2 f2" style={{ color: "092a51" }}>Device Management</h5>
                                        {userRole == Role.mmpl ? (<></>) : (<>
                                            <div className="m-1 flex" onClick={this.NewitemNav}>
                                                <span className="small-title m-auto">Add Device</span><AddIcon />
                                            </div>
                                        </>)}
                                    </div>
                                </div>
                                <div className="search-filter-box">
                                    <div className="row pb-3">
                                        <div className={showSidePane ? "col-md-6 col-lg-12  col-xl-12" : "col-lg-4"}>
                                            <label className="form-label" >ID</label><br></br>
                                            <input className="form-control" type="text" name="id" placeholder="ID" value={this.state.searchData.id} onChange={e => this.handleInputChange(e)}></input>
                                        </div>
                                        <div className={showSidePane ? "col-md-6 col-lg-12 col-xl-12 " : "col-lg-4 "}>
                                            <label className="form-label" >Make</label><br></br>
                                            <input className="form-control" type="text" name="make" placeholder="Make" value={this.state.searchData.make} onChange={e => this.handleInputChange(e)}></input>
                                        </div>
                                        <div className={showSidePane ? "col-md-6 col-lg-12" : "col-lg-4 "}>
                                            <label className="form-label" >Model</label><br></br>
                                            <input className="form-control" type="text" name="modal" placeholder="Model" value={this.state.searchData.modal} onChange={e => this.handleInputChange(e)}></input>
                                        </div>
                                        <div className={showSidePane ? "col-md-6 col-lg-12  col-xl-12" : "col-lg-4 "}>
                                            <label className="form-label" >Manufacturing Date</label><br></br>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="input-group add-on date datepicker" data-date-format="yyyy-mm-dd">
                                                        <input
                                                            type="text"
                                                            value={this.state.searchData.manufacturingFrom}
                                                            className="form-control date-picker"
                                                            placeholder="From"
                                                            name="manufacturingDate"
                                                        ></input>
                                                        <DatePicker selected={this.state.SelectedManufacturingFromDate}
                                                            onChange={this.handleManufacturingFromDateChange}
                                                            onClickOutside={this.handleBlur}
                                                            open={this.state.fromDatePickerManufacturingIsOpen}
                                                            startDate={this.state.SelectedManufacturingFromDate}
                                                            maxDate={this.state.SelectedManufacturingToDate}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            popperPlacement={`${this.state.isMobile ? "top-end" : showSidePane ? "top-end" : "bottom"}`}
                                                            className="form-control date-picker w-5 hide-date" />
                                                        <div
                                                            className="input-group-btn calendar-icon"
                                                            onClick={this.openManufacturingFromDatePicker}>
                                                            <button className="btn btn-default" style={{ height: "100%" }}>
                                                                <i className="fa fa-calendar mt-1"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 margin">
                                                    <div className="input-group add-on date datepicker" data-date-format="yyyy-mm-dd">
                                                        <input
                                                            type="text"
                                                            value={this.state.searchData.manufacturingTo}
                                                            className="form-control date-picker"
                                                            placeholder="To"
                                                            name="manufacturingDate"
                                                        ></input>
                                                        <DatePicker selected={this.state.SelectedManufacturingToDate}
                                                            onClickOutside={this.handleBlur}
                                                            onChange={this.handleManufacturingToDateChange}
                                                            open={this.state.toDatePickerManufacturingIsOpen}
                                                            endDate={this.state.SelectedManufacturingToDate}
                                                            minDate={this.state.SelectedManufacturingFromDate}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            popperPlacement="top-end"
                                                            className="form-control date-picker w-5 hide-date" />
                                                        <div
                                                            className="input-group-btn calendar-icon"

                                                            onClick={this.openManufacturingToDatePicker}
                                                        >
                                                            <button className="btn btn-default" style={{ height: "100%" }}>
                                                                <i className="fa fa-calendar mt-1"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={showSidePane ? "col-md-6 col-lg-12 col-xl-12" : "col-lg-4 "}>
                                            <label className="form-label" >Last Calibration Date</label><br></br>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="input-group add-on date datepicker" data-date-format="yyyy-mm-dd">
                                                        <input
                                                            type="text"
                                                            value={this.state.searchData.lastCalibrationFrom}
                                                            className="form-control date-picker"
                                                            placeholder="From"
                                                            name="lastCalibrationDate"
                                                        ></input>
                                                        <DatePicker selected={this.state.SelectedLastcaliberationFromDate}
                                                            onChange={this.handleLastCaliberationFromDateChange}
                                                            open={this.state.fromDatePickerLastCalibIsOpen}
                                                            onClickOutside={this.handleBlur}
                                                            startDate={this.state.SelectedLastcaliberationFromDate}
                                                            maxDate={this.state.SelectedLastcaliberationToDate}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            popperPlacement={`${this.state.isMobile ? "top-end" : showSidePane ? "bottom-start" : "bottom"}`}
                                                            className="form-control date-picker w-5 hide-date" />
                                                        <div
                                                            className="input-group-btn calendar-icon"
                                                            onClick={this.openLastCaliberationFromDatePicker}
                                                        >
                                                            <button className="btn btn-default" style={{ height: "100%" }}>
                                                                <i className="fa fa-calendar mt-1"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 margin">
                                                    <div className="input-group add-on date datepicker" data-date-format="yyyy-mm-dd">
                                                        <input
                                                            type="text"
                                                            value={this.state.searchData.lastCalibrationTo}
                                                            className="form-control date-picker"
                                                            placeholder="To"
                                                            name="lastCalibrationDate"
                                                        ></input>
                                                        <DatePicker selected={this.state.SelectedLastcaliberationToDate}
                                                            onChange={this.handleLastCaliberationToDateChange}
                                                            open={this.state.toDatePickerLastCalibIsOpen}
                                                            endDate={this.state.SelectedLastcaliberationToDate}
                                                            minDate={this.state.SelectedLastcaliberationFromDate}
                                                            onClickOutside={this.handleBlur}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            popperPlacement={`${this.state.isMobile ? "top-end" : showSidePane ? "bottom-start" : "top-end"}`}

                                                            className="form-control date-picker w-5 hide-date" />
                                                        <div
                                                            className="input-group-btn calendar-icon"
                                                            onClick={this.openLastCaliberationToDatePicker}
                                                        >
                                                            <button className="btn btn-default" style={{ height: "100%" }}>
                                                                <i className="fa fa-calendar mt-1"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={showSidePane ? "col-md-6 col-lg-12 col-xl-12" : "col-lg-4 "}>
                                            <label className="form-label" >Next Calibration Date</label><br></br>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="input-group add-on date datepicker" data-date-format="yyyy-mm-dd">
                                                        <input
                                                            type="text"
                                                            value={this.state.searchData.nextCalibrationFrom}
                                                            className="form-control date-picker"
                                                            placeholder="From"
                                                            name="nextCalibrationDate"
                                                        ></input>
                                                        <DatePicker selected={this.state.SelectedNextcaliberationFromDate}
                                                            onChange={this.handleNextCaliberationFromDateChange}
                                                            open={this.state.fromDatePickerNextCalibIsOpen}
                                                            startDate={this.state.SelectedNextcaliberationFromDate}
                                                            maxDate={this.state.SelectedNextcaliberationToDate}
                                                            onClickOutside={this.handleBlur}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            popperPlacement={`${this.state.isMobile ? "top-end" : "bottom"}`}
                                                            className="form-control date-picker w-5 hide-date" />
                                                        <div
                                                            className="input-group-btn calendar-icon"
                                                            onClick={this.openNextCaliberationFromDatePicker}
                                                        >
                                                            <button className="btn btn-default" style={{ height: "100%" }}>
                                                                <i className="fa fa-calendar mt-1"></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-sm-6 margin">
                                                    <div className="input-group add-on date datepicker" data-date-format="yyyy-mm-dd">
                                                        <input
                                                            type="text"
                                                            value={this.state.searchData.nextCalibrationTo}
                                                            className="form-control date-picker"
                                                            placeholder="To"
                                                            name="nextCalibrationDate"
                                                        ></input>
                                                        <DatePicker selected={this.state.SelectedNextcaliberationToDate}
                                                            onChange={this.handleNextCaliberationToDateChange}
                                                            open={this.state.toDatePickerNextCalibIsOpen}
                                                            onClickOutside={this.handleBlur}
                                                            endDate={this.state.SelectedNextcaliberationToDate}
                                                            minDate={this.state.SelectedNextcaliberationFromDate}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            popperPlacement="top-end"
                                                            className="form-control date-picker w-5 hide-date" />
                                                        <div
                                                            className="input-group-btn calendar-icon"
                                                            onClick={this.openNextCaliberationToDatePicker}
                                                        >
                                                            <button className="btn btn-default" style={{ height: "100%" }}>
                                                                <i className="fa fa-calendar mt-1"></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className={showSidePane ? "col-md-6 col-lg-12  col-xl-12" : "col-lg-4 "}>
                                            <label className="form-label" >Company Name</label><br></br>
                                            <input className="form-control" type="text" name="companyName" placeholder="Company Name" value={this.state.searchData.companyName} onChange={e => this.handleInputChange(e)}></input>
                                        </div>
                                        <div className={showSidePane ? "col-md-6 col-lg-12 col-xl-12" : "col-lg-4 "}>
                                            <label className="form-label" >Ship Name</label><br></br>
                                            <input className="form-control" type="text" name="shipName" placeholder="Ship Name" value={this.state.searchData.shipName} onChange={e => this.handleInputChange(e)}></input>
                                        </div>
                                        <div className={showSidePane ? "col-lg-12 pt-3" : "col-lg-4 pt-3"}>
                                            <br></br>
                                            <div className="search-btn-col" style={{ textAlign: "end" }}>
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.SearchData(1)}>
                                                    {" "}Search  {" "}
                                                </button>
                                                <button
                                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                    type="button" onClick={() => this.ClearInput()}>
                                                    {" "} Clear{" "}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {SearchDevice ?
                        <DeviceManagementCard
                            arraylist={SearchDevice.data}
                            pageSize={SearchDevice.pagination.pageSize}
                            currentPage={SearchDevice.pagination.currentPage}
                            totalRecords={SearchDevice.pagination.totalcount ? SearchDevice.pagination.totalcount : 0}
                            setUpdatedState={(value) => this.SearchData(value)}
                        />
                        : ''}
                </div>
            </div>
        )
    }
    openEditScreen() {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push("/Home/EditClient");
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
        SearchDevice: state.DeviceManagementReducer.SearchDevice
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeviceManagement));

